module.exports = __webpack_public_path__ + "static/media/Ellipse 5.b212ba9c.png";